import React, { type FC } from 'react';
import { Select, Space, Text } from '@g2u/ui-kit';
import cx from 'classnames';

import { type JsonDataItem, type JsonData, type WithOptionalDataTest } from 'types';
import { useText } from 'helpers/hooks/useText';
import { Section } from 'components';
import styles from './hear-about-us.module.scss';

export namespace HearAboutUsFields {
  export type Props = {
    hasScript?: boolean;
    options?: JsonData;
    required?: boolean;
    inline?: boolean;
    readonly?: boolean;
    customer?: JsonDataItem | null;
  } & WithOptionalDataTest;

  export const $: FC<Props> = (props) => {
    const { options, hasScript, inline, required, readonly, customer } = props;
    const { getText } = useText();

    return (
      <Section.$ title="Marketing" inline={inline}>
        <Space.$ direction={Space.Direction.Vertical} size={Space.Size.Middle}>
          {hasScript && (
            <Text.$ size={Text.Size.MD} mark>
              {getText(' booking.payment.howHeardAboutUs')}
            </Text.$>
          )}

          <Select.$
            name="hearAboutUs"
            placeholder="Unknown"
            initialValue={customer?.hear_about_us}
            fullWidth
            required={required}
            readonly={readonly}
            label="Heard about Us:"
            options={options?.map((option: JsonDataItem) => {
              return { value: option.ID.toString(), label: option.description };
            })}
            className={cx(
              styles.hearAboutUs__marketing,
              styles.hearAboutUs__formItem_horizontal,
              styles.hearAboutUs__formItem_left,
            )}
            rules={[{ required }]}
          />
        </Space.$>
      </Section.$>
    );
  };
}
